import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruthruns1getGetScreenTruthRunsResponseSchema = jsonObject
export type tcpscreentruthruns1getGetScreenTruthRunsResponse = z.infer<typeof tcpscreentruthruns1getGetScreenTruthRunsResponseSchema>
export const tcpscreentruthruns1getGetScreenTruthRunsIdResponseSchema = jsonObject
export type tcpscreentruthruns1getGetScreenTruthRunsIdResponse = z.infer<typeof tcpscreentruthruns1getGetScreenTruthRunsIdResponseSchema>
